import { Component } from "@angular/core";
import { ToastService } from "angular-toastify";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { HolidaySettings } from "@interfaces/holidaySettings.interface";
import { HolidaySettingsService } from "@services/holidaySettings.service";

@Component({
	moduleId: module.id,
	selector: "holidaySettings",
	styleUrls: ["holidaySettings.css"],
	templateUrl: "holidaySettings.html"
})
export class HolidaySettingsAdminComponent {
	createEnabled = true;
	editEnabled = true;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	item: HolidaySettings = new HolidaySettings();
	itemType = "Holiday Settings";
	title: string = "Editing " + this.itemType;

	constructor(private toastService: ToastService, private itemService: HolidaySettingsService) {
		this.buildButtons();
		this.getItem();
	}

	buildButtons() {
		this.headerPrimaryButtons = [
			{ method: "updateItem", text: "Save Changes" },
			{ method: "cancelEditing", text: "Cancel Changes" }
		];
	}

	cancelEditing() {
		this.getItem();
	}
	
	getItem() {
		this.itemService.getSettings()
			.subscribe(
				(res: any) => {
					this.item = res.response;
				},
				(err) => {console.log(err); this.toastService.error("Something Went Wrong!");}
			);
	}

	headerButtonClick(method: any) {
		// @ts-ignore // Required to be able to call the method directly from the variable
		if (this[method]) this[method]();
	}

	updateItem() {
		this.itemService.updateSettings(this.item)
			.subscribe(
				() => {
					this.toastService.success("Successfully Updated");
				},
				(err) => {
					console.log(err);
					this.toastService.error("Something Went Wrong!");
				}
			);
	}
}